import Vue from "vue"
import apiClient from "@/utils/cb-client"

import { MANAGE_PAYMENTS } from "@/store/common/auth"
import { checkPaymentGateway, CDN } from "@/components/modules/hosted-pages/LazyLoadPaymentComponents"
import ImportHelper from '@/utils/chunkImportWrapper'

export const hostedPageState = {
  loaded: false,
  request_source: undefined,
  partially_loaded: false
}


const SET_DATA = "SET_DATA";
export const SET_LOADED = "SET_LOADED";
export const SET_PARTIALLY_LOADED = "SET_PARTIALLY_LOADED";
const SET_REQUEST_SOURCE = "SET_REQUEST_SOURCE";
const SET_PREFERRED_CURRENCY_CODE = "SET_PREFERRED_CURRENCY_CODE";

export const hostedPageActions = {
  _fetch_data({commit, state, dispatch, rootState, getters}, token) {
    return new Promise((resolve, reject) => {
      // apiClient.hosted_pages.get({}, {token: token}).then(function(data) {
      try{
        var data = window.hpData;
        commit(SET_DATA, data.content);
        commit(SET_REQUEST_SOURCE, data.content.hp_request_source);
        commit(SET_PREFERRED_CURRENCY_CODE, data.content.preferred_currency_code);

        if(data.content.type == "checkout_gift") {
          dispatch('mark_as_gift', data.content.type == "checkout_gift");
        }
        dispatch('set_pm_list', data.pm_list);
        dispatch('set_action_pages_redirect_url', data.action_pages_redirect_url);
        // rootstate can be authenticated if jwt is being set.
        // authentication will be initied in main.js
        if(rootState.auth.authenticated) {
          // if hosted page cusomer id is different from the authenticated customer id
          if(data.content.customer_handle && data.content.customer_handle != rootState.auth.customer_handle) {
            dispatch('reset_auth');
          }

          if(data.content.hp_request_source == "api" && !data.content.auth_token_type) {
            dispatch('reset_auth');
            window.cbPostMessage("cb.unauthenticated");
          }
        }

        if(rootState.auth.scopes.indexOf(MANAGE_PAYMENTS) > -1 && data.content.type != "manage_payment_sources") {
          dispatch('reset_auth');
        }
        if(data.content.auth_token_type && data.content.auth_token_type == "hp_token") {
          dispatch("set_hp_token_auth", data.content.customer_handle);
        }
        resolve(true);
      }
      catch(error) {
        reject(error)
      };
    }).then(() => {
      if(checkPaymentGateway().loadChargebeejs) {
        return ImportHelper.loadScript(CDN.chargebeejs, null, 'Chargebee').then(() => {
          Chargebee.init({site: getters.site_name, domain: window.location.origin, referrerModule:'checkout_v3'});
          return Chargebee.getInstance().load("3ds-handler");
        });
      }
      else {
        return true;
      }
    });
  // });
  },

  reset_load({commit, state}) {
    commit(SET_PARTIALLY_LOADED, false);
    commit(SET_LOADED, false);
  }
}


export const hostedPageMutations = {
  [SET_DATA] (state, data) {
    Vue.set(state, 'data', data);
  },
  [SET_LOADED] (state, status) {
    state.loaded = status;
  },
  [SET_PARTIALLY_LOADED] (state, status) {
    state.partially_loaded = status;
  },
  [SET_REQUEST_SOURCE] (state, request_source) {
    state.request_source = request_source;
  },
  [SET_PREFERRED_CURRENCY_CODE] (state, preferred_currency_code) {
    state.preferred_currency_code = preferred_currency_code;
  }
}

export const hostedPageGetters = {
  hp_partially_loaded: state => state.partially_loaded,
  hp_loaded: state => state.loaded,
  hp_type: state => state.data && state.data.type,
  is_checkout_new: (state, getters) => getters.hp_type == "checkout_new",
  is_checkout_existing: (state, getters) => getters.hp_type == "checkout_existing",
  is_checkout_gift: (state, getters) => getters.hp_type == "checkout_gift",
  is_claim_gift: (state, getters) => getters.hp_type == "claim_gift",
  hp_request_source: state => state.request_source,
  is_hp_from_api: state => state.request_source == "api",
  is_hp_from_plan: state => state.request_source == "plan",
  preferred_currency_code: state => state.preferred_currency_code,
  can_edit_billing_address: (state, getters) => {
    return getters.subscription_count == 0 || (getters.is_checkout_existing && getters.subscription_count == 1);
  }
}


// WEBPACK FOOTER //
// ./src/store/common/hosted-page.js